module.exports = __webpack_public_path__ + "img/case-logo-16.a02456f2.png";